import Dialog, { DialogHeader, DialogContent } from 'xpi-black-ui/Common/Dialog';
import styled from 'styled-components';

const WrapperDialog = styled(Dialog).attrs(() => ({ height: 'auto', width: '950px' }))``;
export default WrapperDialog;

export const WrapperHeader = styled(DialogHeader)``;

export const WrapperDialogContent = styled(DialogContent)`
  display: flex;
  background-color: #3F4147;
`;

export const WrapperDialogContentLegs = styled.div`
  margin-right: 0.8rem;
  width: 50%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  border-right: 2px #FFC200 dashed;
`;

export const WrapperDialogContentInformation = styled.div`
  padding: 0 1rem 0 0.5rem;
  overflow-y: auto;
  width: 65%;
  height: 400px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.25rem;
`;

export const WrapperPositionInformation = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ isFullWidth }) => isFullWidth ? '100%' : '49%'};
`;

export const WrapperLegInformation = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const WrapperLegInfo = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: baseline;
`;
